<script>

    import {createEventDispatcher} from "svelte";
    import {searchKeyword} from "../api.svelte"
    import {getLocalPropertyId} from "../../utils/session";

    export let keyword;
    export let allowDropdown;
    let keywordList = false;
    let query = "";
    let showDropdown = false;

    let propertyId = getLocalPropertyId();

    let searchTime = 0;

    const dispatch = createEventDispatcher();

    let establishQuery = (event) => {

        query = event.target.value;

        clearTimeout(searchTime);

        if (allowDropdown) {

            searchTime = setTimeout(() => {
                assembleKeywordsList();
            }, 500);

            return;

        }

        keyword = query;
        eventDispatcher('newkeyword');

    }

    let assembleKeywordsList = () => {

        searchKeyword(query, propertyId).then((data) => {

            if (data['status'] !== 'success') {

                console.log('Chart fetch failed.');
                return;

            }

            keywordList = data['matches'];

            showDropdown = true;

        });

    }

    let handleKeywordClick = (keyworditem) => {

        keyword = keyworditem;
        keywordList = false;
        query = "";
        showDropdown = false;

        eventDispatcher('newkeyword');

    };

    let resetKeywordSearch = () => {

        keyword = "";
        keywordList, showDropdown = false;
        query = "";

        eventDispatcher('reset');

    };


    let eventDispatcher = (type) => {

        let action = {
            'type': type,
            'keyword': keyword
        };

        dispatch('searchevent', action);

    };

</script>




<div id="keyword-search"  class:expanded={showDropdown && query !== ""}>

    <input type="text" placeholder="Keyword suchen" bind:value={keyword} on:input={(e) => establishQuery(e)}/>

    <div id="img-search" class="icon-container" class:show={!keyword}>
        <img src="images/icon-search.svg" alt=""/>
    </div>

    <div id="img-clear" class="icon-container" class:show={keyword} on:click={() => resetKeywordSearch()}>
        <img src="images/icon-close.svg" alt="" />
    </div>

    <div class="dropdown">

        {#if keywordList.length}

            {#each keywordList as item}

                <div class="keyword-item" on:click={() => handleKeywordClick(item)}>{item}</div>

            {/each}

        {/if}

        <div id="no-results" class="keyword-item" class:show={!keywordList.length && showDropdown}>Keine Resultate.</div>

    </div>

</div>

<style>

    #keyword-search {
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: calc(30.22vh - (2 * 0.78vw));
        height: 3.56vh;
        padding: 0 1.39vh;
        background-color: #FFFFFF;
        border-radius: 1.39vh;
        font-family: 'Raleway', sans-serif;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        
    }

    #keyword-search input {
        display: flex;
        width: 23.11vh;
        padding: 0;
        margin: 0;
        border: 0;
        outline: 0;
        background-color: transparent;
        font-family: inherit;
        font-weight: 300;
        font-size: 1.78vh;
        color: #383874;
    }

    #keyword-search .icon-container {
        display: none;
        position: absolute;
        right: 0;
        height: inherit;
        padding: 0 1.39vh;
        cursor: pointer;
    }

    #keyword-search .icon-container.show {
        display: flex;
    }

    #keyword-search .icon-container#img-search img {
        width: 1.78vh;
    }

    #keyword-search .icon-container#img-clear img {
        width: 1.42vh;
    }

    #keyword-search .dropdown {
        max-height: 20vh;
        overflow-y: scroll;
    }

    #keyword-search .dropdown .keyword-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 1.42vh;
    }

    #keyword-search .dropdown .keyword-item#no-results {
        display: none;
    }

    #keyword-search .dropdown .keyword-item#no-results.show {
        display: flex;
    }
    .expanded .dropdown {
        display: flex;
        z-index: 3;
    }

    .dropdown {
        position: absolute;
        display: none;
        flex-direction: column;
        width: 100%;
        min-height: 100%;
        left: 0;
        top: calc(100% + 0.89vh);
        background-color: #FFFFFF;
        border-radius: 1.39vh;
        font-family: 'Raleway', sans-serif;
        font-size: 1.78vh;
        font-weight: 400;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.09);
    }

    .dropdown .keyword-item {
        cursor: pointer;
    }

</style>